// @flow
import * as React from 'react';
import SidePane from 'esm-web-pro/components/layout/SidePane';
import ApiForm from 'esm-web-pro/containers/forms/ApiForm';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sidePanelActionCreators from 'esm-web-pro/redux/side-panel/actions';
import { get } from 'lodash';

type SidePanelActionProps = {
    closePanel: (key: string, skipSensitivity: boolean) => { key: string },
}

type Props = {
    ...$Exact<SidePanelActionProps>,
    object: Object,
    id: string,
    editorTitle: React.Node,
    editorTitleLabel?: string,
    resourceName: string,
    idAccessor?: string,
    excludeFields?: Array<string>,
    onSave: Function,
    onCancel: Function,
    initial: Object,
    onSubmit: Function,
    resourceArguments?: Array<any>,
    customForm?: React.ComponentType,
    forwardedRef: React.Ref<ApiForm>,
    customFormProps?: Object,
}

const Editor = (props: Props) => {
    const {
        closePanel, object, id, editorTitle, resourceName, idAccessor, excludeFields,
        onSave, onCancel, initial, onSubmit, editorTitleLabel, resourceArguments, customForm: CustomForm,
        forwardedRef, customFormProps, ...rest
    } = props;

    const handleSave = () => {
        closePanel(id, true);
        onSave();
    };

    const handleCancel = () => {
        closePanel(id, false);
        onCancel();
    };
    const Form = CustomForm || ApiForm;
    return (
        <>
            <SidePane
                id={id}
                title={editorTitle}
                titleLabel={editorTitleLabel}
            >
                <>
                    <Form
                        resourceName={resourceName}
                        objectId={get(object, idAccessor)}
                        onSuccess={handleSave}
                        onClose={handleCancel}
                        height="100%"
                        excludeFields={excludeFields}
                        initial={initial}
                        onSubmit={onSubmit}
                        resourceArguments={resourceArguments}
                        partialUpdate
                        ref={forwardedRef}
                        {...customFormProps}
                        {...rest}
                    />
                </>
            </SidePane>
        </>
    );
};

Editor.defaultProps = {
    idAccessor: 'uuid',
    excludeFields: [],
    onSave() {},
    onSubmit() {},
    onCancel() {},
    initial: undefined,
    editorTitleLabel: null,
    resourceArguments: [],
    customForm: null,
    customFormProps: {},
};

export default connect(
    null, (dispatch) => (bindActionCreators(sidePanelActionCreators, dispatch)), null, { forwardRef: true },
)(
    React.forwardRef((props, ref) => <Editor {...props} forwardedRef={ref} />),
);
